export const validationCategory = (category: string) =>
  [
    'aneis',
    'aliancas',
    'aneis-solitarios',
    'meia-aliancas',
    'brincos',
    'colares',
    'correntes',
    'pingentes',
    'pulseiras',
  ].includes(category)
